import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Treeable from '../common/Treeable'
import Component from '../common/Component'
import externalIdActions from '../../actions/BenefitsSetExternalIds'
import withRouter from '../../lib/withRouter'

export class BenefitsSetExternalIdShow extends Component {
  static propTypes = {
    show: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    externalId: PropTypes.object,
    params: PropTypes.object.isRequired
  }

  componentDidMount() {
    this.props.show(this.id)
  }

  componentWillUnmount() {
    this.props.reset()
  }

  get id() {
    return this.props.params.id
  }

  get shouldRender() {
    return this.props.externalId
  }

  get treeComponents() {
    return (
      this.props.externalId.zip_counties.map((tree, index) => (
        <Treeable
          key={`${tree.name}_${index}`}
          name={tree.name}
          data={tree}
        />
      ))
    )
  }

  render() {
    const { externalId } = this.props

    if (!this.shouldRender) return null

    return (
      <div className="content">
        <h1>External ID</h1>

        <h5>Metadata</h5>
        <table className="pure-table zip_county_info">
          <tbody>
            <tr>
              <td><strong>External ID</strong></td>
              <td name="external_id">{externalId.external_id}</td>
            </tr>
            <tr>
              <td><strong>Type</strong></td>
              <td name="type">{externalId.external_id_type}</td>
            </tr>
            <tr>
              <td><strong>Number of Counties</strong></td>
              <td name="fips_code_count">{externalId.fips_code_count}</td>
            </tr>
            <tr>
              <td><strong>Number of Zip Codes</strong></td>
              <td name="zip_code_count">{externalId.zip_code_count}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <h5>Zip Counties</h5>
        <div className="tree">
          {this.treeComponents}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const showSlice = state.BenefitsSetExternalIds.show
  const configuration = state.login.session.configuration

  return {
    externalId: showSlice.attributes,
    configuration
  }
}

const mapDispatchToProps = {
  show: externalIdActions.show.main,
  reset: externalIdActions.show.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BenefitsSetExternalIdShow))
